import React, { useState } from "react";

import Fooduserorders from "./Fooduserorders";
import Fooduserwalletorders from './Fooduserwalletorders';
import FoodLiveOrders from "./FoodLiveOrders";
import DeliveryLiveOrders from "./DeliveryLiveOrders";
import OnlineRestaurents from "./OnlineRestaurents";

import { useNotification } from "../../../../context/Notifications/NotificationContext";


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Online");
  const { notifications, clearNotifications } = useNotification();

  const tabs = [
    "Online",
    "orders",
    "Live orders",
    "Delivery orders",

  ];

  // When tab is clicked, clear its notifications
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    clearNotifications(tab);
  };

  const renderComponent = () => {
    switch (activeTab) {
      case "Online":
        return <OnlineRestaurents />;
      case "orders":
        return <Fooduserorders />;
      case "Live orders":
        return <FoodLiveOrders />;
      case "Delivery orders":
        return <DeliveryLiveOrders />;

      default:
        return <OnlineRestaurents />;
    }
  };

  return (
    <>
      <div className="tabs-wrapper" style={{ width: "77vw" }}>
        <div className="tabs-row">
          {tabs.map((tab) => {
            const notificationCount = notifications[tab] || 0;
            const hasNotification = notificationCount > 0;

            return (
              <span
                key={tab}
                className={`row-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
                style={{ position: 'relative' }}
              >
                {tab}
                {hasNotification && (
                  // <span
                  //   style={{
                  //     position: 'absolute',
                  //     top: '-8px',
                  //     right: '-8px',
                  //     background: '#dc2626',
                  //     color: 'white',
                  //     borderRadius: '50%',
                  //     padding: '2px 6px',
                  //     fontSize: '10px',
                  //     fontWeight: 'bold',
                  //     minWidth: '18px',
                  //     textAlign: 'center',
                  //     animation: 'pulse 1.5s ease-in-out infinite'
                  //   }}
                  // >
                  //   {notificationCount > 9 ? '9+' : notificationCount}
                  // </span>
                  <span
                    style={{
                      position: 'absolute',
                      top: '-6px',
                      right: '-6px',
                      width: '12px',
                      height: '12px',
                      background: '#dc2626',
                      borderRadius: '50%',
                      animation: 'pulse 1.5s ease-in-out infinite',
                      boxShadow: '0 0 6px rgba(220, 38, 38, 0.6)'
                    }}
                  />
                )}
              </span>
            );
          })}
        </div>

        <div className="tabs-content">
          {renderComponent()}
        </div>
      </div>
      <style>
        {`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
      `}
      </style>
    </>
  );
};

export default TabsLayout;